import { useSelector } from "react-redux"
import { useEffect } from "react";

function PaymentMethods({selectedPayment, setSelectedPayment}){
    const isCOD = useSelector((state) => state.fetchUser?.user?.isCOD);
      useEffect(() => {
    if (typeof isCOD === "boolean") {
      if (isCOD && !selectedPayment) {
        setSelectedPayment("COD");
      } else if (!isCOD) {
        setSelectedPayment("PREPAID");
      }
    }
  }, [isCOD, selectedPayment, setSelectedPayment]);
    
    return (
        <>
            <div className="common-heading">
                <h6>Payment Method</h6>
            </div>
            <div className="payment-method">
                <div className="payment-option">
                    <label>
                        <input type="radio" name="payment"  value="PREPAID"
                               checked={selectedPayment === "PREPAID"}
                               onChange={() => setSelectedPayment("PREPAID")}/>
                        <span>Online Payment</span>
                    </label>
                    <div className="payment-description">
                        UPI, Credit Card, Net Banking, Wallet, EMI, BNPL
                    </div>
                    {/* <div className="payment-discount">Get 5% Discount on Prepaid Order</div> */}
                </div>
                {isCOD && (<div className="payment-option">
                    <label>
                        <input type="radio" name="payment" value="COD"  checked={selectedPayment === "COD"}
                               onChange={() => setSelectedPayment("COD")}/>
                        <span>Cash on Delivery</span>
                    </label>
                    {/* <div className="payment-description shipment-charges">
                        ₹200 Shipment Charges Extra
                    </div> */}
                </div>)}
            </div>
        </>
    )
}
export default PaymentMethods